import React, { useState, useEffect, useRef } from 'react';
import { useStateValue } from './StateProvider.js';
import axios from 'axios';
import configData from './Config';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import ReactToPrint from 'react-to-print';
import Title from './Title.js';
import Spinner from './Spinner.js';
import { numberToWords } from './Utils/textparse.js';
import Select from './Components/select.js';
import { registerArabicFont } from "./Utils/registerarabicfont.js";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import Header from './Header.js';

import './CollectionsOverview.css';

const CHECKINTERVAL = 300000; // 300000 ms = 5 minutes

//20240525

function CollectionsOverview({ state, setState }) {
    const [{ projects }, dispatch] = useStateValue();

    const [collections, setCollections] = useState([]);
    const [filteredcollections, setFilteredcollections] = useState([]);
    const [grouptedcollections, setGroupedcollections] = useState([]);

    const [option, setOption] = useState('pending');
    const [user, setUser] = useState(state.user.userid);

    const [refresh, setRefresh] = useState(false);
    const [loading, setLoading] = useState(false);

    const [loadingpdf, setLoadingpdf] = useState(false);
    const [resultpdf, setResultpdf] = useState('');

    const printRef = useRef();

    useEffect(() => {
        let data = [...collections];

        if (user) {
            data = data.filter(c => c.userid === user);
        }

        const grouped = [];
        let currentDay = null;

        if (option) {
            data = data.filter(c => c.status === option);
            if (option == 'pending') {
                data.sort((a, b) => b.ts - a.ts);
                setFilteredcollections(data)
            }
            if (option == 'received') {
                data.sort((a, b) => b.completedts - a.completedts);
                data.forEach(c => {
                    const day = moment.unix(c.completedts).format('YYYY-MM-DD');
                    if (day !== currentDay) {
                        grouped.push({ day, items: [] });
                        currentDay = day;
                    }

                    grouped[grouped.length - 1].items.push(c);
                });
                setFilteredcollections(data)
                setGroupedcollections(grouped);
            }
        }
        else {
            data.sort((a, b) => b.ts - a.ts);
            data.forEach(c => {
                const day = moment.unix(c.ts).format('YYYY-MM-DD');
                if (day !== currentDay) {
                    grouped.push({ day, items: [] });
                    currentDay = day;
                }

                grouped[grouped.length - 1].items.push(c);
            });
            setFilteredcollections(data)
            setGroupedcollections(grouped);
        }
    }, [collections, user, option]);

    const handleCloseModal = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    }

    const handleViewReceipt = (collection, due) => {
        if (collection.userid != state.user.userid) {
            setState(state => ({ ...state, modalopen: true, modalcontent: <NotUser collection={collection} />, modaltype: 'small', modaltitle: 'Not User' }));
        }
        else {
            if ((collection.status === 'pending' && due)) setState(state => ({ ...state, modalopen: true, modalcontent: <ViewReceipt collection={collection} />, modaltype: 'small', modaltitle: 'View Receipt' }));
            if ((collection.status === 'pending' && !due)) setState(state => ({ ...state, modalopen: true, modalcontent: <NotDue collection={collection} />, modaltype: 'small', modaltitle: 'Not Due' }));
            if ((collection.status === 'received')) setState(state => ({ ...state, modalopen: true, modalcontent: <ViewReceipt collection={collection} />, modaltype: 'small', modaltitle: 'View Receipt' }))
        }
    }

    const handleViewPayment = (collection, due) => {
        if (collection.userid != state.user.userid) {
            setState(state => ({ ...state, modalopen: true, modalcontent: <NotUser collection={collection} />, modaltype: 'small', modaltitle: 'Not User' }));
        }
        else {
            if ((collection.status === 'pending' && due)) setState(state => ({ ...state, modalopen: true, modalcontent: <ViewPayment collection={collection} />, modaltype: 'small', modaltitle: 'View Payment' }));
            if ((collection.status === 'pending' && !due)) setState(state => ({ ...state, modalopen: true, modalcontent: <NotDue collection={collection} />, modaltype: 'small', modaltitle: 'Not Due' }));
            if ((collection.status === 'received')) setState(state => ({ ...state, modalopen: true, modalcontent: <ViewPayment collection={collection} />, modaltype: 'small', modaltitle: 'View Payment' }))
        }
    }

    useEffect(() => {
        const fetchCollections = () => {
            const uniqueIds = projects.map(project => project.userid).filter((userId, index, array) => array.indexOf(userId) === index);
            console.log('Trying to get collections overview');

            setLoading(true);

            if (uniqueIds.length > 0) {
                setCollections([]);
                uniqueIds.forEach(userId => {
                    const data = {
                        projectuserid: userId
                    };

                    axios.post(configData.CONTROLLERURL + configData.GETCOLLECTIONSOVERVIEW, data, {
                        headers: {
                            "Accept": "application/json",
                            "Content-Type": "application/json;charset=UTF-8",
                            "userid": state.user.userid,
                            "usertoken": state.user.usertoken
                        }
                    }).then((res) => {
                        console.log('Collections overview data received');
                        console.log(res.data);
                        if (res.data instanceof Array) {
                            setCollections(prevEntries => [...prevEntries, ...res.data]);
                        }
                    }).catch((err) => {
                        console.log(err);
                    }).finally(() => {
                        setLoading(false);
                    });
                });
            }
        };

        fetchCollections();
        const interval = setInterval(fetchCollections, CHECKINTERVAL);
        return () => clearInterval(interval);
    }, [refresh]);

    function ViewReceipt({ collection }) {
        const [projectuserid, setProjectuserid] = useState('');
        const [projectid, setProjectid] = useState('');
        const [id, setId] = useState('');

        const [loading, setLoading] = useState(false);
        const [result, setResult] = useState(null);

        const receiptPrintRef = useRef();

        useEffect(() => {
            setProjectuserid(collection.projectuserid)
            setProjectid(collection.projectid)
            setId(collection.id)
        }, [collection])

        const markCollection = (status) => {
            console.log('Trying to mark collection');

            setLoading(true)

            const data = {
                projectuserid: projectuserid,
                projectid: projectid,
                id: id,
                status: status
            };

            axios.post(configData.CONTROLLERURL + configData.MARKCOLLECTION, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Mark collection data received');
                console.log(res.data);
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        handleCloseModal();
                        setRefresh(!refresh)
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error')
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        };

        const handleShare = () => {
            const projectName = projects.find(project => project.projectid === collection.projectid)?.name || 'Project';
            const receiptText =
                "RECEIPT\n" +
                "COPY FOR CLIENT\n" +
                "Receipt ID     : " + collection.id + "\n" +
                "Project Name   : " + projectName + "\n" +
                "\n" +
                "Client Information\n" +
                "Client Name    : " + collection.clientname + "\n" +
                "\n" +
                "Payment Details\n" +
                "Description    : " + collection.description + "\n" +
                "Amount Paid    : " + collection.currencysymbol + " " + collection.amount + "\n" +
                "Amount in Words: " + numberToWords(collection.amount) + " " + collection.currencyname + "\n" +
                "\n" +
                "Collector Information\n" +
                "Collector      : " + state.user.username + "\n" +
                "\n" +
                "Date           : " + moment().format('D/MMM/YYYY hh:mm:ss A') + "\n" +
                "\n" +
                "Thank you for your payment!\n" +
                "\n";

            if (navigator.share) {
                navigator.share({
                    title: 'Receipt',
                    text: receiptText,
                }).then(() => {
                    markCollection('received')
                }).catch((error) => {
                    console.error('Error sharing:', error)
                });

            } else {
                alert('Web Share API is not supported in your browser.');
            }
        };

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='collectionsoverview_printable' ref={receiptPrintRef}>
                        <pre className='collectionsoverview_printablepre'>
                            {
                                "RECEIPT\n" +
                                "**COPY FOR CLIENT**\n" +
                                "Receipt ID     : " + collection.id + "\n" +
                                "Project Name   : " + projects.find(project => project.projectid === collection.projectid)?.name + "\n" +
                                "\n" +
                                "Client Information\n" +
                                "Client Name    : " + collection.clientname + "\n" +
                                "\n" +
                                "Payment Details\n" +
                                "Description    : " + collection.description + "\n" +
                                "Amount Paid    : " + collection.currencysymbol + " " + collection.amount + "\n" +
                                "Amount in Words: " + numberToWords(collection.amount) + " " + collection.currencyname + "\n" +
                                "\n" +
                                "Collector Information\n" +
                                "Collector      : " + state.user.username + "\n" +
                                "\n" +
                                "Date           : " + moment().format('D/MMM/YYYY hh:mm:ss A') + "\n" +
                                "\n" +
                                "Thank you for your payment!\n"
                            }
                        </pre>
                    </div>
                </div>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <div className='collectionsoverview_markbutton' onClick={() => markCollection('received')} disabled={loading}>Received - استلام</div>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <div className="collectionsoverview_sharebutton" onClick={handleShare} disabled={loading}>Share</div>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <ReactToPrint
                                trigger={() => (<div className="collectionsoverview_sharebutton">Print</div>)}
                                content={() => receiptPrintRef.current}
                            />
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <div className='collectionsoverview_closebutton' onClick={handleCloseModal}>Close</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function ViewPayment({ collection }) {
        const [projectuserid, setProjectuserid] = useState('');
        const [projectid, setProjectid] = useState('');
        const [id, setId] = useState('');

        const [loading, setLoading] = useState(false);
        const [result, setResult] = useState(null);

        const paymentprintRef = useRef();

        useEffect(() => {
            setProjectuserid(collection.projectuserid)
            setProjectid(collection.projectid)
            setId(collection.id)
        }, [collection])

        const markCollection = (status) => {
            console.log('Trying to mark collection');

            setLoading(true)

            const data = {
                projectuserid: projectuserid,
                projectid: projectid,
                id: id,
                status: status
            };

            axios.post(configData.CONTROLLERURL + configData.MARKCOLLECTION, data, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                    "userid": state.user.userid,
                    "usertoken": state.user.usertoken
                }
            }).then((res) => {
                console.log('Mark collection data received');
                console.log(res.data);
                if (res.data instanceof Object) {
                    if (res.data.code === 1) {
                        handleCloseModal();
                        setRefresh(!refresh)
                    }
                    else {
                        setResult(res.data.data)
                    }
                }
                else {
                    setResult('Error')
                }
            }).catch((err) => {
                setResult(err.response?.data?.message || err.message || 'Network error');
            }).finally(() => {
                setLoading(false);
            });
        };

        const handleShare = () => {
            const projectName = projects.find(project => project.projectid === collection.projectid)?.name || 'Project';
            const receiptText =
                "PAYMENT VOUCHER\n" +
                "COPY FOR PAYER\n" +
                "Receipt ID     : " + collection.id + "\n" +
                "Project Name   : " + projectName + "\n" +
                "\n" +
                "Beneficiary Information\n" +
                "Beneficiary    : " + collection.suppliername + "\n" +
                "\n" +
                "Payment Details\n" +
                "Description    : " + collection.description + "\n" +
                "Amount Paid    : " + collection.currencysymbol + " " + collection.amount + "\n" +
                "Amount in Words: " + numberToWords(collection.amount) + " " + collection.currencyname + "\n" +
                "\n" +
                "Payer Information\n" +
                "Payer          : " + state.user.username + "\n" +
                "\n" +
                "Date           : " + moment().format('D/MMM/YYYY hh:mm:ss A') + "\n" +
                "\n" +
                "Thank you for your services!\n" +
                "\n";

            if (navigator.share) {
                navigator.share({
                    title: 'Payment',
                    text: receiptText,
                }).then(() => {
                    markCollection('received')
                }).catch((error) => {
                    console.error('Error sharing:', error)
                });
            } else {
                alert('Web Share API is not supported in your browser.');
            }
        };

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='collectionsoverview_printable' ref={paymentprintRef}>
                        <pre className='collectionsoverview_printablepre'>
                            {
                                "PAYMENT VOUCHER\n" +
                                "**COPY FOR PAYER**\n" +
                                "Payment ID      : " + collection.id + "\n" +
                                "Project Name    : " + projects.find(project => project.projectid === collection.projectid)?.name + "\n" +
                                "\n" +
                                "Beneficiary Information\n" +
                                "Beneficiary     : " + collection.suppliername + "\n" +
                                "\n" +
                                "Payment Details\n" +
                                "Description     : " + collection.description + "\n" +
                                "Amount Paid     : " + collection.currencysymbol + " " + collection.amount + "\n" +
                                "Amount in Words : " + numberToWords(collection.amount) + " " + collection.currencyname + "\n" +
                                "\n" +
                                "Payer Information\n" +
                                "Payer           : " + state.user.username + "\n" +
                                "\n" +
                                "Date            : " + moment().format('D/MMM/YYYY hh:mm:ss A') + "\n" +
                                "\n" +
                                "Thank you for your services!\n"
                            }
                        </pre>
                    </div>
                </div>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <div className='collectionsoverview_markbutton' onClick={() => markCollection('received')} disabled={loading}>Paid - تم الدفع</div>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <div className="collectionsoverview_sharebutton" onClick={handleShare} disabled={loading}>Share</div>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <ReactToPrint
                                trigger={() => (<div className="collectionsoverview_sharebutton">Print</div>)}
                                content={() => paymentprintRef.current}
                            />
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <div className='collectionsoverview_closebutton' onClick={handleCloseModal}>Close</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function NotDue() {
        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>
                                Not Due
                            </div>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <div className='collectionsoverview_closebutton' onClick={handleCloseModal}>Close</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    function NotUser() {
        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>
                                This item is for other user
                            </div>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <div className='collectionsoverview_closebutton' onClick={handleCloseModal}>Close</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function renderSummary(label, collections, payments) {
        const receivedTotals = [];
        const paidTotals = [];

        collections
            .forEach(c => {
                const item = receivedTotals.find(t => t.currency === c.currencysymbol);
                if (item) {
                    item.amount += parseInt(c.amount, 10);
                } else {
                    receivedTotals.push({ currency: c.currencysymbol, amount: parseInt(c.amount, 10) });
                }
            });

        payments
            .forEach(c => {
                const item = paidTotals.find(t => t.currency === c.currencysymbol);
                if (item) {
                    item.amount += parseInt(c.amount, 10);
                } else {
                    paidTotals.push({ currency: c.currencysymbol, amount: parseInt(c.amount, 10) });
                }
            });

        return (
            <div className="collectionsoverview_summary">
                {label && <div className="collectionsoverview_summarylabel">{label}</div>}
                {receivedTotals.map(({ currency, amount }, index) => (
                    <div className="collectionsoverview_summaryitem" key={'item' + index}>
                        <div className="collectionsoverview_summaryitemkey">Total Receipts</div>
                        <div className="collectionsoverview_summaryitemvalue">{currency} {amount.toLocaleString('en-US')}</div>
                    </div>
                ))}

                {paidTotals.map(({ currency, amount }, index) => (
                    <div className="collectionsoverview_summaryitem" key={'item' + index}>
                        <div className="collectionsoverview_summaryitemkey">Total Payments</div>
                        <div className="collectionsoverview_summaryitemvalue">{currency} {amount.toLocaleString('en-US')}</div>
                    </div>
                ))}
            </div>
        );
    }

    const allusers = Object.values(
        collections.reduce((acc, c) => {
            acc[c.userid] ??= { id: c.userid, name: c.username || '' };
            return acc;
        }, {})
    );

    const saveasPDF = () => {
        return
        setLoadingpdf(true);

        try {
            const doc = new jsPDF();
            registerArabicFont(doc);

            const pageWidth = doc.internal.pageSize.getWidth();
            let currentY = 20;

            doc.setFontSize(20);
            const title = 'Collections Overview';
            doc.text(title, pageWidth / 2, currentY, { align: 'center' });

            currentY += 10;

            const tableColumn = [
                'Created',
                'Due',
                'Completed',
                'Project',
                'Stakeholder',
                'Amount',
                'Description',
                'Note',
                'Status',
            ];

            const body = [];

            if (option !== 'pending') {
                grouptedcollections.forEach(group => {
                    body.push([
                        {
                            content: moment(group.day).format('dddd, D MMM YYYY'),
                            colSpan: 9,
                            styles: {
                                fontStyle: 'bold',
                                fillColor: [240, 240, 240],
                                halign: 'left',
                            },
                        },
                    ]);

                    group.items.forEach(collection => {
                        const due =
                            moment().endOf('day').unix() >=
                            moment.unix(collection.atts).endOf('day').unix();

                        body.push([
                            moment.unix(collection.ts).format('D MMM YYYY HH:mm'),
                            moment.unix(collection.atts).format('dddd'),
                            collection.completedts
                                ? moment.unix(collection.completedts).format('D MMM YYYY HH:mm')
                                : '',
                            projects.find(p => p.projectid === collection.projectid)?.name || '',
                            collection.type === 'receipt'
                                ? collection.clientname
                                : collection.suppliername,
                            `${collection.currencysymbol} ${collection.amount}`,
                            collection.description || '',
                            collection.note || '',
                            collection.status === 'pending'
                                ? due
                                    ? 'pending'
                                    : 'not due'
                                : 'received',
                        ]);
                    });

                    // Summary row (same logic as UI)
                    body.push([
                        {
                            content: renderSummary(
                                '',
                                group.items.filter(c => c.type === 'receipt'),
                                group.items.filter(c => c.type === 'payment')
                            ),
                            colSpan: 9,
                            styles: {
                                fontStyle: 'bold',
                                halign: 'right',
                            },
                        },
                    ]);
                });
            } else {
                // FLAT MODE (pending)
                filteredcollections.forEach(collection => {
                    const due =
                        moment().endOf('day').unix() >=
                        moment.unix(collection.atts).endOf('day').unix();

                    body.push([
                        moment.unix(collection.ts).format('D MMM YYYY HH:mm'),
                        moment.unix(collection.atts).format('dddd'),
                        collection.completedts
                            ? moment.unix(collection.completedts).format('D MMM YYYY HH:mm')
                            : '',
                        projects.find(p => p.projectid === collection.projectid)?.name || '',
                        collection.type === 'receipt'
                            ? collection.clientname
                            : collection.suppliername,
                        `${collection.currencysymbol} ${collection.amount}`,
                        collection.description || '',
                        collection.note || '',
                        collection.status === 'pending'
                            ? due
                                ? 'pending'
                                : 'not due'
                            : 'received',
                    ]);
                });
            }

            autoTable(doc, {
                head: [tableColumn],
                body,
                startY: currentY,
                theme: 'grid',
                styles: {
                    font: 'notoarabic',
                    fontSize: 9,
                },
                headStyles: {
                    fillColor: [200, 200, 200],
                    textColor: [0, 0, 0],
                    fontStyle: 'bold',
                },
                margin: { left: 10, right: 10 },
            });

            doc.save('collections_overview.pdf');
            setResultpdf('Saved Successfully');
        } catch (err) {
            console.error(err);
            setResultpdf('Error Saving PDF');
        } finally {
            setLoadingpdf(false);
        }
    };

    return (
        <div className='collectionsoverview'>
            <Header state={state} setState={setState} />

            <div className='buttonscontainer'>
                <div className='buttonsection'><button className={user == '' ? 'button buttonactive' : 'button'} onClick={() => setUser('')}>All users</button></div>
                <div className='buttonsection'><button className={user == state.user.userid ? 'button buttonactive' : 'button'} onClick={() => setUser(state.user.userid)}>Me</button></div>
                <div className='buttonsection'>
                    <Select data={allusers} itemid={user} setItemid={setUser} />
                </div>
            </div>

            <div className='buttonscontainer'>
                <div className='buttonsection'><button className={option == '' ? 'button buttonactive' : 'button'} onClick={() => setOption('')}>All</button></div>
                <div className='buttonsection'><button className={option == 'pending' ? 'button buttonactive' : 'button'} onClick={() => setOption('pending')}>Pending</button></div>
                <div className='buttonsection'><button className={option == 'received' ? 'button buttonactive' : 'button'} onClick={() => setOption('received')}>Received</button></div>
                <div className='buttonsection'><button className={option == 'received' ? 'button buttonactive' : 'button'} onClick={() => saveasPDF()}>Save as PDF</button></div>
                <div className='buttonsection'>
                    <ReactToPrint
                        trigger={() => (<button className="button">Print</button>)}
                        content={() => printRef.current}
                    />
                </div>
            </div>

            <div className='collectionsoverview_printable' ref={printRef}>
                <Title text='COLLECTIONS OVERVIEW' />
                <div className='collectionsoverview_tablecontainer'>
                    <table className='collectionsoverview_table'>
                        <thead>
                            <tr>
                                <th>Created</th>
                                <th>Due</th>
                                <th>Completed</th>
                                <th>Project</th>
                                <th>Stakeholder</th>
                                <th>Amount</th>
                                <th>Description</th>
                                <th>Note</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading && <tr><td colSpan={8}><Spinner loading={loading} size={30} /></td></tr>}
                            {
                                option == 'pending' &&
                                filteredcollections
                                    .map((collection, index) => {
                                        const due = moment().endOf('day').unix() >= moment.unix(collection.atts).endOf('day').unix();

                                        if (collection.type === 'receipt') {
                                            return (
                                                <tr
                                                    key={'receipt' + index}
                                                    className='collectionsoverview_collection'
                                                    onClick={() => handleViewReceipt(collection, due)}
                                                >
                                                    <td><div>{moment.unix(collection.ts).format('dddd, D MMM YYYY hh:mm:ss A')}</div></td>
                                                    <td><div>{moment.unix(collection.atts).format('dddd')}</div></td>
                                                    <td><div>{collection.completedts ? moment.unix(collection.completedts).format('dddd, D MMM YYYY hh:mm:ss A') : null}</div></td>
                                                    <td><div>{projects.find(project => project.projectid === collection.projectid)?.name}</div></td>
                                                    <td><div>{collection.clientname}</div></td>
                                                    <td><div>{collection.currencysymbol} {collection.amount}</div></td>
                                                    <td><div>{collection.description}</div></td>
                                                    <td><div>{collection.note}</div></td>
                                                    {collection.status === 'pending' && due && <td><div className='collections_statuspending'>pending</div></td>}
                                                    {collection.status === 'pending' && !due && <td><div className='collections_statusnotdue'>not due</div></td>}
                                                    {collection.status === 'received' && <td><div className='collections_statusreceived'>received</div></td>}
                                                </tr>
                                            )
                                        }
                                        if (collection.type === 'payment') {
                                            return (
                                                <tr key={'payment' + index}
                                                    className='collectionsoverview_payment'
                                                    onClick={() => handleViewPayment(collection, due)}
                                                >
                                                    <td><div>{moment.unix(collection.ts).format('dddd, D MMM YYYY hh:mm:ss A')}</div></td>
                                                    <td><div>{moment.unix(collection.atts).format('dddd')}</div></td>
                                                    <td><div>{collection.completedts ? moment.unix(collection.completedts).format('dddd, D MMM YYYY hh:mm:ss A') : null}</div></td>
                                                    <td><div>{projects.find(project => project.projectid === collection.projectid)?.name}</div></td>
                                                    <td><div>{collection.suppliername}</div></td>
                                                    <td><div>{collection.currencysymbol} {collection.amount}</div></td>
                                                    <td><div>{collection.description}</div></td>
                                                    <td><div>{collection.note}</div></td>
                                                    {collection.status === 'pending' && due && <td><div className='collections_statuspending'>pending</div></td>}
                                                    {collection.status === 'pending' && !due && <td><div className='collections_statusnotdue'>not due</div></td>}
                                                    {collection.status === 'received' && <td><div className='collections_statusreceived'>received</div></td>}
                                                </tr>
                                            )
                                        }
                                    })
                            }
                            {
                                option != 'pending' &&
                                grouptedcollections.map(group => (
                                    <React.Fragment key={group.day}>
                                        <tr>
                                            <td colSpan={9}>
                                                <div className="collections_sectionheader">
                                                    {moment(group.day).format('dddd, D MMM YYYY')}
                                                </div>
                                            </td>
                                        </tr>

                                        {
                                            group.items
                                                .map((collection, index) => {
                                                    const due = moment().endOf('day').unix() >= moment.unix(collection.atts).endOf('day').unix();

                                                    if (collection.type === 'receipt') {
                                                        return (
                                                            <tr
                                                                key={'receipt' + index}
                                                                className='collectionsoverview_collection'
                                                                onClick={() => handleViewReceipt(collection, due)}
                                                            >
                                                                <td><div>{moment.unix(collection.ts).format('dddd, D MMM YYYY hh:mm:ss A')}</div></td>
                                                                <td><div>{moment.unix(collection.atts).format('dddd')}</div></td>
                                                                <td><div>{collection.completedts ? moment.unix(collection.completedts).format('dddd, D MMM YYYY hh:mm:ss A') : null}</div></td>
                                                                <td><div>{projects.find(project => project.projectid === collection.projectid)?.name}</div></td>
                                                                <td><div>{collection.clientname}</div></td>
                                                                <td><div>{collection.currencysymbol} {collection.amount}</div></td>
                                                                <td><div>{collection.description}</div></td>
                                                                <td><div>{collection.note}</div></td>
                                                                {collection.status === 'pending' && due && <td><div className='collections_statuspending'>pending</div></td>}
                                                                {collection.status === 'pending' && !due && <td><div className='collections_statusnotdue'>not due</div></td>}
                                                                {collection.status === 'received' && <td><div className='collections_statusreceived'>received</div></td>}
                                                            </tr>
                                                        )
                                                    }
                                                    if (collection.type === 'payment') {
                                                        return (
                                                            <tr key={'payment' + index}
                                                                className='collectionsoverview_payment'
                                                                onClick={() => handleViewPayment(collection, due)}
                                                            >
                                                                <td><div>{moment.unix(collection.ts).format('dddd, D MMM YYYY hh:mm:ss A')}</div></td>
                                                                <td><div>{moment.unix(collection.atts).format('dddd')}</div></td>
                                                                <td><div>{collection.completedts ? moment.unix(collection.completedts).format('dddd, D MMM YYYY hh:mm:ss A') : null}</div></td>
                                                                <td><div>{projects.find(project => project.projectid === collection.projectid)?.name}</div></td>
                                                                <td><div>{collection.suppliername}</div></td>
                                                                <td><div>{collection.currencysymbol} {collection.amount}</div></td>
                                                                <td><div>{collection.description}</div></td>
                                                                <td><div>{collection.note}</div></td>
                                                                {collection.status === 'pending' && due && <td><div className='collections_statuspending'>pending</div></td>}
                                                                {collection.status === 'pending' && !due && <td><div className='collections_statusnotdue'>not due</div></td>}
                                                                {collection.status === 'received' && <td><div className='collections_statusreceived'>received</div></td>}
                                                            </tr>
                                                        )
                                                    }
                                                })
                                        }
                                        < tr >
                                            <td colSpan={9}>
                                                {renderSummary('', group.items.filter(c => c.type === 'receipt'), group.items.filter(c => c.type === 'payment'))}
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={9}>
                                    {
                                        option == 'pending' &&
                                        <>
                                            {
                                                renderSummary(
                                                    'Due',
                                                    filteredcollections.filter(c => c.type === 'receipt' && moment().endOf('day').unix() >= moment.unix(c.atts).endOf('day').unix()),
                                                    filteredcollections.filter(c => c.type === 'payment' && moment().endOf('day').unix() >= moment.unix(c.atts).endOf('day').unix())
                                                )
                                            }
                                            {
                                                renderSummary(
                                                    'Not Due',
                                                    filteredcollections.filter(c => c.type === 'receipt' && moment().endOf('day').unix() < moment.unix(c.atts).endOf('day').unix()),
                                                    filteredcollections.filter(c => c.type === 'payment' && moment().endOf('day').unix() < moment.unix(c.atts).endOf('day').unix())
                                                )
                                            }
                                        </>
                                    }
                                    {option != 'pending' &&
                                        renderSummary(
                                            '',
                                            filteredcollections.filter(c => c.type === 'receipt'),
                                            filteredcollections.filter(c => c.type === 'payment')
                                        )
                                    }
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div >
        </div >
    );
}

export default CollectionsOverview;